// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_57ffe40b","outerContainer":"d96689bd","secondaryToolbar":"d056de99","doorHangerRight":"_6bfaa98c","toolbarContainer":"_6f2ad3f4","toolbarViewerMiddle":"_2ec0c56a","progressBar":"_65491335","back-to-application":"_8c3d8905","wrapper":"c4d5a79a","unit":"f56dfa20","textWrapper":"f400322a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/LabTestHistoryLegend/index.styl
// module id = 5060
// module chunks = 39